import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";

import { getActivityListByClaim, fetchFilter, setPanelVisibility } from "../../../containers/WorkkardDetail/actions/action";
import { showDialogueBox, hideDialogueBox } from '../../../components/DialogueBox/actions';
import { setActivityId } from "../../../containers/WorkkardDetail/actions/commonAction";
import ActivityListing from "../../../components/ActivityListing";
import ListingComponent from "../../../components/ListingComponent";
import ChoseReason from "../../../components/ChoseReason";
import { WorkkardActions, CHOOSE_AN_ACTIVITY_TEMPLATE, ACTIVITY_LIST_PAGE_SIZE, StringConstants, LeftPanelConstant,RightPanelConstant } from '../../../containers/WorkkardDetail/constants';
import * as CommonUtil from '../../../common/util';
import { SeturlHash } from '../../../containers/WorkkardDetail/utils';
import {ActivityListingLoader} from '../../../components/SkeletonLoader';
import Icon from '../../../icons';
import ConsolidatedViewFilter from '../CombinedView/Filter';
import {
  hideToast
} from '../../SpockViewPage/actions/action';
import { TOOLTIP_DELAY_TIME } from '../../SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../../../components/Tooltip/constants';
import MultipleMiniProfile from '../../../components/MultipleMiniProfile';
import EmptyScreen from '../../../Emptyscreen';
import ConfirmationTextBox from "../../../components/ConfirmationPrompt";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useLiveRefresh } from '../../../utils/useLiveRefresh';
import { selectLiveSelectedActivity, clearSelectedActivity } from '../../../common/slice/liveUpdates';

const LeftPanelContainer = (props) => {
  const dispatch = useDispatch();
  const activities = useSelector(state => state.workkardDetail.activityListing);
  const workkard = useSelector(state => state.workkardDetail.workkardDetail);
  const isLoading = useSelector(state => state.isLoading);
  const toggleView = useSelector(state => state.workkardDetail.panelVisibility.toggleView);
  const sessionContext = useSelector(selectSessionContextOidc);
  const userView = sessionContext?.userView;
  const userPermission = userView?.permissions;

  const [clickedActivityId, setClickedActivityId] = React.useState(0);
  const [canCreateActivity, setCanCreateActivity] = React.useState(false);

  const stateRef = React.useRef({});
  stateRef.current = { clickedActivityId, canCreateActivity };

  const refreshActListingRef = React.useRef(null);
  refreshActListingRef.current = () => {
    const { skip, take } = activities;
    const payload = {
      skip: 0,
      take: Math.max((skip || 0) + (take || 0), ACTIVITY_LIST_PAGE_SIZE),
      cId: workkard.Id,
    };
    dispatch(getActivityListByClaim(payload));
  };

  // An event on this claim refreshes the listing through the container, which
  // owns the pagination the socket middleware cannot reconstruct. Scoped to this
  // claim: the user also receives events for every other claim they act on.
  useLiveRefresh(['activity'], () => refreshActListingRef.current(), { workkardId: workkard?.Id });

  const isCombinedView = () => toggleView === RightPanelConstant.CombinedViewText;

  const selectActivity = (activityId, { replaceUrl = false } = {}) => {
    setClickedActivityId(activityId);
    dispatch(setActivityId({ id: activityId }));
    if (!isCombinedView()) {
      SeturlHash(false, activityId, workkard.Id, props.history, null, false, replaceUrl);
    }
  };

  React.useEffect(() => {
    if (!window.hasOwnProperty("refresh_actlisting")) {
      window.addEventListener("refresh_actlisting", () => refreshActListingRef.current());
    }
    if (workkard && workkard?.ActionMenu?.length > 0) {
      let actionArray = CommonUtil.getMenuActions(WorkkardActions, workkard.ActionMenu);
      let canCreateAct = actionArray.filter(function (item) {
        return item.value.includes(StringConstants.CreateActivity);
      });
      if (canCreateAct.length > 0) {
        setCanCreateActivity(true);
      } else if (stateRef.current.canCreateActivity) { setCanCreateActivity(false); }
    }
    if (activities && activities.currentActivity) {
      setClickedActivityId(activities.currentActivity);
    }
    return () => {
      window.removeEventListener("refresh_actlisting", () => refreshActListingRef.current());
    };
  }, [workkard]);

  React.useEffect(() => {
    const { activities: actList, currentActivity } = activities;
    if (actList.length > 0 && !currentActivity) {
      const { actId: urlActId } = queryString.parse(props.history?.location?.search) || {};
      const urlActivity = urlActId && actList.find((item) => String(item.activityId) === String(urlActId));
      // The backend returns the list already sorted, so actList[0] is the latest activity.
      // replace, not push: auto-selection corrects the url rather than navigating
      selectActivity((urlActivity || actList[0]).activityId, { replaceUrl: true });
    }
    // if(workkard.Id !== undefined && prevWorkkardId !== workkard.Id){
    //   //TODO need to  identify template  type  here
    //   // fetch filter for  associated  workkard
    //   dispatch(fetchFilter({ templateType: 'HCI', wkId: workkard.Id }))
    // }
  }, [activities.activities, activities.currentActivity]);

  React.useEffect(() => {
    if (activities && activities.currentActivity && activities.currentActivity != stateRef.current.clickedActivityId) {    
      setClickedActivityId(activities.currentActivity);
    }
  }, [activities.currentActivity]);

  // An activity this tab created, or one its reassignment handed the work over
  // to, becomes the selected one. The listing itself is refreshed by the nudge
  // above; the selection does not wait for it, the row highlights as soon as the
  // refreshed list arrives.
  const liveSelectedActivitySelector = React.useMemo(
    () => selectLiveSelectedActivity(workkard?.Id),
    [workkard?.Id],
  );
  const liveSelectedActivity = useSelector(liveSelectedActivitySelector);

  React.useEffect(() => {
    if (!liveSelectedActivity) return;
    const { actId: urlActId } = queryString.parse(props.history?.location?.search) || {};
    if (String(urlActId) !== String(liveSelectedActivity.activityId)) {
      selectActivity(liveSelectedActivity.activityId);
    }
    dispatch(clearSelectedActivity());
  }, [liveSelectedActivity]);

  const onItemClick = (activityId) => {
    if (!activityId || activityId == stateRef.current.clickedActivityId) {
      return;
    }
    selectActivity(activityId);
  };


  const onScrollHandler = () => {
    if (activities.isLoader) return;
    const loadedCount = activities.activities?.length ?? 0;
    if (loadedCount >= activities.total) return;

    const nextTake = Math.min(ACTIVITY_LIST_PAGE_SIZE, activities.total - loadedCount);
    const payload = {
      skip: loadedCount,
      take: nextTake,
      cId: workkard.Id
    };
    dispatch(getActivityListByClaim(payload));
  };

  const closeDialogBox = () => {
    dispatch(showDialogueBox({
      flag: false,
      dialogueBoxComponent: null,
    }));
  };

  const closeConfirmationBox = () => {
    dispatch(hideDialogueBox());
  };

  const onCreateActivityClick = () => {
    const history = Object.assign({}, props.history);
    let component = null;
    let contentClassName = "modalContent medium animated faster fadeInUpx2";

    if (workkard.WorkkardStatus === 'CLOSE'
    //&& (workkard.OrganizationId === userView.orgId)
    && !userPermission?.can_reopen_workkard) {
      contentClassName = "modalContent small animated faster fadeInUpx2";
      component = <ConfirmationTextBox
        header={"Cannot Create Activity!"}
        class={"modalBody"}
        message={LeftPanelConstant.CanReopenWorkkardPermissionDenied}
        onConfirmClick={closeConfirmationBox}
        confirmationText={"Close"}
        footerClass={"modalFooter"}
      />;
    } else {
      component = <ChoseReason history={history} isCreateActivity={true} wkid={workkard.Id} title={CHOOSE_AN_ACTIVITY_TEMPLATE} onClose={closeDialogBox} />;
    }

    dispatch(showDialogueBox({
      flag: true,
      component: component,
      overlayClassName: "modal",
      contentClassName: contentClassName,
      shouldCloseOnOverlayClick: true,
    }));
  };

  const onCellClick = (payload) => {
    payload.propertylocation = workkard.CustomFields && workkard.CustomFields.filter(x => x.FieldKey == "propertylocation_state_state").length > 0 && workkard.CustomFields.filter(x => x.FieldKey == "propertylocation_state_state")[0].Value;
    const { target, data, propertylocation } = payload;
    if (data && data.length > 0) {
      dispatch({
        type: SHOW_TOOLTIP,
        payload: {
          delay: TOOLTIP_DELAY_TIME,
          target,
          position: 'right',
          childComponent: <MultipleMiniProfile data={data} wklocation={propertylocation}/>,
        }
      });
    }
  };

  const renderActivitiesList = (activitiesList) => {
    if (activitiesList && activitiesList.length > 0) {
      const prop = {
        data: activitiesList,
        cellTemplate: ActivityListing,
        onScrollHandler: onScrollHandler,
        onItemClick: onItemClick,
        type: "ul",
        classname: 'cardScroll scrollArea',
        selectedId: clickedActivityId,
        onCellClick: onCellClick,
        extraData: {
          sessionContext,
        }
      };
      return (<ListingComponent {...prop} />);
    }
    return <EmptyScreen name="Emptyactivity" />;
  };

  const renderView = (view, filter) => {
    switch (view) {
      case RightPanelConstant.NormalView.toLowerCase():
        return renderActivityListingView();
      case RightPanelConstant.CombinedViewText.toLowerCase():
        return renderCombinedView(filter);
      default:
        return null;
    }
  };

  const renderActivityListingView = () => {
    let { activities: actList } = activities;
    const activityId = activities.currentActivity;
    return (
      <React.Fragment>
        <div className="activity-listing" data-test={`activityListing ${activityId}`}>
          {(isLoading && actList.length < 1) &&
            <ActivityListingLoader count={5} /> ||
            renderActivitiesList(actList)
          }
        </div>
      </React.Fragment>
    );
  };

  const renderCombinedView = (filter) => {
    return (<ConsolidatedViewFilter setfilter={filter} />);
  };

  let { total } = activities;
  let { showInPopUp } = props;
  let className = showInPopUp ? "firstLayout layoutFilterMob animated faster slideInLeft" : "firstLayout";
  return (
    <div className={className}>
      {showInPopUp && <div className="alignMiddle rowSpaceBetween mb">
        <span><strong>Filters</strong></span>
        <div style={{ zIndex: 1 }} onClick={props.closeCbFilter}><Icon name="close" className="icon" /></div>
      </div>}
      {
        toggleView.includes(RightPanelConstant.CombinedViewText)
          ?
          null
          :
          <header className="activityHeading alignMiddle" data-test={`activityHeading ${total}`}>
            <h2 className="alignMiddle">
              {LeftPanelConstant.ActivitiesText} ({ total || 0 }) {canCreateActivity && <button className="btn btnAdd buttonGradient addIcon ml" onClick={onCreateActivityClick} title="Add activity"><Icon name="add" className="icon" /></button>}
            </h2>
          </header>
      }
      {
        renderView(toggleView.toLowerCase(), props.setfilter)
      }
    </div>
  );
};

export default LeftPanelContainer;
